import { useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'

import { Grid } from '@material-ui/core'

import { useForm } from 'react-hook-form'

import { Input } from 'components/forms'
import { SaveButton } from 'components/buttons'

import { StyledSubHeading } from 'components/headings'

import { saveRegistry } from 'registry/api'
import { setRegistry } from 'registry/actions'
import { FLASH_MESSAGE } from '../../../shared/constants'

import css from './BirthdayRegistryInfo.scss'

interface BirthdayRegistryInfoProps {
  onSubmit?: (data: any) => Promise<any>
}

export const BirthdayRegistryInfo = ({
  onSubmit = saveRegistry,
}: BirthdayRegistryInfoProps) => {
  const {
    id: registryId,
    title: registryTitle,
    description: registryDescription,
    urlSlug: registryUrlSlug,
    attributeData: { firstName = '', birthdate = '' } = {},
  } = useSelector((state: any) => state.registry)

  const [submitting, setSubmitting] = useState(false)

  const dispatch = useDispatch()

  const { register, handleSubmit, errors, setError } = useForm({
    defaultValues: {
      registry: {
        id: registryId,
        title: registryTitle,
        description: registryDescription,
        url_slug: registryUrlSlug,
        registry_attributes_attributes: {
          registry_type: 'birthday',
          attribute_data: {
            first_name: firstName,
            birthdate: birthdate,
          },
        },
      },
    },
  })

  const dispatchSubmit = (data: any) => {
    setSubmitting(true)
    onSubmit(data)
      .then(({ registry }) => {
        setSubmitting(false)
        dispatch(setRegistry(registry))
        PubSub.publish(FLASH_MESSAGE, {
          message: 'Your registry info has been updated!',
          variant: 'success',
        })
      })
      .catch(({ error: { message, fields } }) => {
        PubSub.publish(FLASH_MESSAGE, {
          message: message,
          variant: 'error',
        })

        if (fields?.registry?.urlSlug) {
          setError('registry[url_slug]', 'custom', fields.registry.urlSlug)
        }

        setSubmitting(false)
      })
  }

  return (
    <>
      <StyledSubHeading>Registry Info</StyledSubHeading>
      <form
        onSubmit={handleSubmit(dispatchSubmit)}
        className={css.BirthdayRegistryInfo}
      >
        <Grid container spacing={2}>
          <input
            name="registry[id]"
            ref={register({ required: true })}
            type="hidden"
          />
          <input
            defaultValue="birthday"
            name="registry[registry_attributes_attributes][registry_type]"
            ref={register({ required: true })}
            type="hidden"
          />

          <Grid item xs={12}>
            <Input
              error={
                errors.registry?.registry_attributes_attributes?.attribute_data
                  ?.first_name?.message
              }
              id="first_name"
              inputRef={register({ required: 'First name is required' })}
              label="First Name"
              name="registry[registry_attributes_attributes][attribute_data][first_name]"
            />
          </Grid>

          <Grid item xs={12}>
            <Input
              error={
                errors.registry?.registry_attributes_attributes?.attribute_data
                  ?.birthdate?.message
              }
              id="birthdate"
              inputRef={register({ required: 'Birth date is required' })}
              label="Birth Date"
              name="registry[registry_attributes_attributes][attribute_data][birthdate]"
              type="date"
              max={new Date().toISOString().split('T')[0]}
            />
          </Grid>

          <Grid item xs={12}>
            <Input
              error={errors.registry?.title?.message}
              id="registry_title"
              inputRef={register({ required: "Registry Title can't be blank" })}
              label="Registry Title"
              name="registry[title]"
            />
          </Grid>

          <Grid item xs={12}>
            <Input
              error={errors.registry?.url_slug?.message}
              id="registry_url_slug"
              name="registry[url_slug]"
              inputRef={register({ required: "Registry Url can't be blank" })}
              label="Registry Url"
              addonBefore="babylist.com/list/"
            />
          </Grid>

          <Grid item xs={12}>
            <Input
              name="registry[description]"
              id="registry_greeting"
              inputRef={register()}
              label="Registry Greeting"
              type="textarea"
            />
          </Grid>

          <Grid item xs={12}>
            <SaveButton submitting={submitting} className={''}>
              Save
            </SaveButton>
          </Grid>
        </Grid>
      </form>
    </>
  )
}
